import axios from './axios';

export const getCaveats = ({ params } = {}) => axios.get(`caveats`, { params });
export const getCaveat = ({ params, id } = {}) => axios.get(`caveats/${id}`, { params });
export const createCaveat = ({ data }) => axios.post(`caveats`, data);
export const updateCaveat = ({ id, data }) => axios.put(`caveats/${id}`, data);
export const deleteCaveat = ({ id }) => axios.delete(`caveats/${id}`);